module.exports = __webpack_public_path__ + "static/media/nesa.15b94868.png";